import { render, staticRenderFns } from "./RadioboxLoader.vue?vue&type=template&id=19b7c765"
import script from "./RadioboxLoader.vue?vue&type=script&lang=js"
export * from "./RadioboxLoader.vue?vue&type=script&lang=js"
import style0 from "./RadioboxLoader.vue?vue&type=style&index=0&id=19b7c765&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports